import { createSlice } from "@reduxjs/toolkit";

const userFilter = createSlice({
    name: "userFilter",
    initialState: {
        userFilterCount: null,
        isLoaded: false,
    },
    reducers: {
        getUserFilterCount(state, _action) {
            return { ...state, isLoaded: false }
        },
        setUserFilterCount(state, action) {
            const count = action.payload;
            return { ...state, userFilterCount: count, isLoaded: true };
        },
    },
});

export const {
    getUserFilterCount,
    setUserFilterCount
} = userFilter.actions;

export default userFilter.reducer;
